import { fabricColorTotals, fabricTotals, metersLabel, resolveFabrics } from "@/lib/cutTickets";

const low = (x) => (x || "").trim().toLowerCase();
const EXTRA = 0.07;
const withExtra = (m) => m * (1 + EXTRA);

// Totale metri per tessuto e per colore, con il tessuto esatto da scalare
export const FabricColorTotals = ({ t, fabrics, mats }) => {
  const colors = t.lines.map((l) => l.color.trim()).filter(Boolean);
  const rows = fabricColorTotals(t.markers, colors);
  const matFor = (fabric, color) => {
    const line = t.lines.find((l) => low(l.color) === low(color));
    const type = fabrics.find((f) => low(f) === low(fabric))
      || mats.find((m) => m.type === "tessuto" && low(m.name) === low(fabric))?.fabric_type || fabric;
    const id = line && resolveFabrics(line, [type], mats, t.bom_colors)[type];
    return mats.find((m) => m.id === id);
  };
  return (
    <div className="rounded-md border border-border bg-secondary/30 px-3 py-2 text-xs" data-testid="ticket-fabric-totals">
      <p className="mb-1 font-semibold">Metri da scalare per tessuto e colore</p>
      <p className="mb-1.5 text-[11px] text-muted-foreground">Consumo dei grafici + 7% per difetti del tessuto e margine di stesura (scalato dal magazzino quando il lotto passa in taglio)</p>
      {rows.length ? (
        <div className="grid gap-x-6 gap-y-1 sm:grid-cols-2">
          {rows.map((r) => {
            const m = matFor(r.fabric, r.color);
            return (
              <div key={`${r.fabric}-${r.color}`} className="flex items-center justify-between gap-3" data-testid={`ticket-total-${low(r.fabric)}-${low(r.color)}`}>
                <span>{r.fabric} · <span className="font-medium">{r.color}</span>
                  <span className={`ml-1 ${m ? "text-muted-foreground" : "text-amber-400"}`}>{m ? `(${m.name}${m.supplier ? ` – ${m.supplier}` : ""})` : "(tessuto da scegliere)"}</span>
                </span>
                <span className="whitespace-nowrap text-right">
                  <span className="text-muted-foreground">{metersLabel(r.meters)} + 7% = </span>
                  <b data-testid={`ticket-total-extra-${low(r.fabric)}-${low(r.color)}`}>{metersLabel(withExtra(r.meters))}</b>
                </span>
              </div>
            );
          })}
        </div>
      ) : <p className="text-muted-foreground">Scrivi lunghezza e strati dei grafici per vedere i metri.</p>}
      <p className="mt-1.5 border-t border-border/60 pt-1.5 text-muted-foreground">Totale per tessuto (con 7%): {fabricTotals(t.markers).map(([f, mt]) => `${f} ${metersLabel(withExtra(mt))} (grafici ${metersLabel(mt)})`).join(" · ")}</p>
    </div>
  );
};
